export enum Size {
  'xsmall' = 'xsmall',
  'small' = 'small',
  'medium' = 'medium',
  'large' = 'large',
  'xlarge' = 'xlarge',
}

export type SizeType = keyof typeof Size;

export type AnchorRel = 'alternate' | 'author' | 'bookmark' | 'external' | 'help' | 'license' | 'me' | 'next' | 'nofollow' | 'noopener' | 'noreferrer' | 'opener' | 'prev' | 'privacy-policy' | 'search' | 'tag' | 'terms-of-service';

export type AnchorRels = `${AnchorRel}` | `${AnchorRel} ${AnchorRel}` | `${AnchorRel} ${AnchorRel} ${AnchorRel}`;

export type AnchorTarget = '_blank' | '_self' | '_parent' | '_top';

export type AnchorReferrerPolicy = 'no-referrer' | 'no-referrer-when-downgrade' | 'origin' | 'origin-when-cross-origin' | 'same-origin' | 'strict-origin' | 'strict-origin-when-cross-origin' | 'unsafe-url';
